var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentNewIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      zoom: 1.2,
      marginLeft: "-1px"
    },
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4ZM7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.76142 14.7614 12 12 12C9.23858 12 7 9.76142 7 7ZM9.92597 14.2049C10.1345 14.7163 9.889 15.2999 9.3776 15.5084C7.06131 16.453 5.5 18.5813 5.5 20.9999C5.5 21.5522 5.05228 21.9999 4.5 21.9999C3.94772 21.9999 3.5 21.5522 3.5 20.9999C3.5 17.6777 5.641 14.8723 8.6224 13.6565C9.1338 13.448 9.71743 13.6935 9.92597 14.2049Z",
    fill: "currentFill"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_793_6042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3562 20.3728L23.325 20.927C23.0772 20.9946 22.9533 21.0284 22.8518 21.0956C22.7621 21.155 22.6855 21.2331 22.6269 21.3248C22.5608 21.4284 22.5271 21.5553 22.4596 21.8092L21.9067 23.889L21.3668 21.8057C21.3009 21.5515 21.2679 21.4244 21.2025 21.3204C21.1445 21.2283 21.0684 21.1498 20.979 21.0897C20.878 21.022 20.7543 20.9874 20.5068 20.9182L18.4792 20.3514L20.5103 19.7973C20.7582 19.7297 20.8821 19.6958 20.9835 19.6287C21.0733 19.5692 21.1499 19.4911 21.2084 19.3994C21.2746 19.2958 21.3083 19.1689 21.3758 18.9151L21.9287 16.8352L22.4686 18.9185C22.5345 19.1727 22.5674 19.2998 22.6329 19.4039C22.6909 19.4959 22.767 19.5745 22.8564 19.6345C22.9574 19.7023 23.0811 19.7369 23.3285 19.8061L25.3562 20.3728Z",
    fill: "currentFill"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_793_6042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1785 21.1811L16.1216 21.4377C15.9926 21.469 15.9281 21.4846 15.8753 21.5157C15.8286 21.5433 15.7888 21.5795 15.7583 21.622C15.7239 21.67 15.7064 21.7288 15.6713 21.8465L15.384 22.8107L15.1026 21.8447C15.0683 21.7269 15.0511 21.6679 15.017 21.6197C14.9869 21.577 14.9472 21.5405 14.9007 21.5127C14.8481 21.4813 14.7837 21.4652 14.655 21.4331L13.5996 21.1699L14.6566 20.9134C14.7855 20.8821 14.85 20.8664 14.9028 20.8353C14.9495 20.8077 14.9894 20.7716 15.0198 20.7291C15.0542 20.681 15.0717 20.6222 15.1068 20.5045L15.3942 19.5403L15.6755 20.5063C15.7098 20.6242 15.727 20.6831 15.7611 20.7314C15.7913 20.7741 15.8309 20.8105 15.8774 20.8383C15.93 20.8698 15.9944 20.8858 16.1232 20.918L17.1785 21.1811Z",
    fill: "currentFill"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_793_6042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3191 15.9965L18.827 16.3511C18.6449 16.3943 18.5539 16.416 18.4794 16.459C18.4135 16.4971 18.3572 16.5471 18.3142 16.6058C18.2657 16.6722 18.2409 16.7536 18.1914 16.9162L17.7858 18.249L17.3885 16.9137C17.3401 16.7507 17.3158 16.6693 17.2677 16.6026C17.2251 16.5436 17.1691 16.4932 17.1034 16.4547C17.0292 16.4112 16.9383 16.389 16.7565 16.3446L15.2666 15.9808L16.7587 15.6262C16.9408 15.5829 17.0319 15.5613 17.1063 15.5183C17.1723 15.4802 17.2286 15.4302 17.2715 15.3714C17.3201 15.305 17.3448 15.2237 17.3943 15.0611L17.7999 13.7282L18.1972 15.0636C18.2457 15.2265 18.2699 15.308 18.3181 15.3747C18.3607 15.4337 18.4166 15.4841 18.4823 15.5226C18.5565 15.566 18.6474 15.5883 18.8293 15.6327L20.3191 15.9965Z",
    fill: "currentFill"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_793_6042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.2771,
    height: 14.7037,
    fill: "white",
    transform: "translate(26.6094 11.9094) rotate(90.1784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_793_6042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.36054,
    height: 4.77184,
    fill: "white",
    transform: "translate(17.7812 19.0027) rotate(90.1784)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_793_6042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.0278,
    height: 6.73672,
    fill: "white",
    transform: "translate(21.1699 12.9854) rotate(90.1784)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentNewIcon);
export default __webpack_public_path__ + "static/media/agentNewIcon.c91654b5af5b612c41eef67a5a973b99.svg";
export { ForwardRef as ReactComponent };